import Shop from '@/shop';
import YandexEcommerce from '@/extensions/yandex/ecommerce';
import YandexTurbo from '@/extensions/yandex/turbo';

function initYandexExtension() {
  const counterSettings = Shop.config.get('counter_settings').counter_settings;
  const new_counters_setup = counterSettings.new_counters_setup;

  if (!new_counters_setup) {
    new YandexEcommerce();
  }

  new YandexTurbo();
}

document.addEventListener('DOMContentLoaded', initYandexExtension);
